/**
 * size-guide.js
 * Behaviour for the fullscreen "Finding Your Fit" size-guide modal
 * (markup: snippets/size-guide-modal.liquid). Loaded once via layout/theme.liquid
 * on huipil product templates. No-ops on pages where the modal isn't present.
 */
(function () {
  'use strict';

  // Move the modal out to <body> so its position:fixed escapes the header's
  // transform stacking context and covers the nav + announcement bar.
  const modal = document.getElementById('sizechartModal');
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const openSizechart = () => {
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.classList.add('size-chart-open');
  };

  const closeSizechart = () => {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('size-chart-open');
  };

  document.addEventListener('click', (e) => {
    // Open on the trigger link/button.
    if (e.target.closest('.size-chart__trigger') || e.target.closest('a[href="#sizechartModal"]')) {
      e.preventDefault();
      openSizechart();
    }
    // Close on the × button, or on a click on the dark backdrop (the outer
    // overlay itself — not its inner content).
    if (e.target.closest('.size-chart__close') || e.target.id === 'sizechartModal') {
      closeSizechart();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSizechart();
  });

  // --- Tab switching -----------------------------------------------------
  // Each tab button carries data-tab-target="#panel-id"; each panel carries
  // data-tab-content. Clicking a tab flips the .active class — CSS owns the
  // showing/hiding (.size-chart-panel { display: none } / .active { display: block }).
  const tabs = document.querySelectorAll('[data-tab-target]');
  const tabContents = document.querySelectorAll('[data-tab-content]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget);

      tabContents.forEach((content) => content.classList.remove('active'));
      tabs.forEach((t) => t.classList.remove('active'));

      tab.classList.add('active');
      if (target) target.classList.add('active');
    });
  });

  // Start with the first tab active so the modal opens on one panel, not all.
  if (tabs.length) tabs[0].click();
})();
